import assert from 'owa-assert/lib/assert';
import type { MailboxInfo } from 'owa-client-types';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';
import OutlookFavorites from 'owa-service/lib/contract/OutlookFavorites';
import { getStore } from '../store/store';

export default function getFavorites(mailboxInfo: MailboxInfo): OutlookFavorites | undefined {
    const key = getIndexerValueForMailboxInfo(mailboxInfo);
    const accountScopeUserSettings = getStore().accountScopeUserSettingsMap.get(key);
    assert(!!accountScopeUserSettings);
    return accountScopeUserSettings.Favorites;
}
